module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cn":{"about_us":"关于我们","talents":"人才","shop":"商店","gallery":"画廊","study":"课程","news":"新闻","contact_us":"联系我们"},"en":{"about_us":"About","talents":"Talent","shop":"Shop","gallery":"Gallery","study":"Learn","news":"News","contact_us":"Contact"}}')
  delete Component.options._Ctor
}
